import { render, staticRenderFns } from "./RateForm.vue?vue&type=template&id=1cedf2b0&scoped=true"
import script from "./RateForm.vue?vue&type=script&lang=js"
export * from "./RateForm.vue?vue&type=script&lang=js"
import style0 from "./RateForm.vue?vue&type=style&index=0&id=1cedf2b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cedf2b0",
  null
  
)

export default component.exports